import { v4 as uuid } from 'uuid';

import { transactionRulesActions } from 'app-components/flux/transaction-rules/transactionRulesSlice';
import {
  ResolutionTypeEnum,
  type TransactionRuleType,
} from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { computeTxnRuleTrackingProps } from 'app-components/flux/transaction-rules/transactionRulesUtils';
import { tracker } from 'app-components/utils/core';
import type { AppDispatch } from 'store';

import { buildRuleConditions } from './ruleDialogUtils';

type SubmitTransactionRuleArgs = {
  dispatch: AppDispatch;
  rule: TransactionRuleType;
};

export const submitTransactionRule = ({ dispatch, rule }: SubmitTransactionRuleArgs): void => {
  const ruleConditions = buildRuleConditions(rule);

  if (rule.id) {
    dispatch(transactionRulesActions.update({ ...rule, id: rule.id }));
  } else {
    dispatch(transactionRulesActions.create({ ...rule, clientId: uuid().toUpperCase() }));
  }

  tracker.track(tracker.events.txnRuleCompleted, {
    userAction: ResolutionTypeEnum.REPLACE,
    applyPast: rule.applyToExistingTransactions,
    rule: ruleConditions,
    ...computeTxnRuleTrackingProps(rule),
  });
};
